import { CustomLabel } from 'modules/timesheet-labels/labelSchema';
import { scoredSuggestions } from '../scoredSuggestions';
import { FacetOption } from '../type';
import { GetCustomLabelOptionsType } from './hooks/useGetCustomLabelOptions';

export const customLabelScoredSuggestions = (
  customLabels: CustomLabel[],
  getOptions: GetCustomLabelOptionsType
) => async (phrase = ''): Promise<FacetOption[]> => {
  const results = await Promise.all(
    customLabels.map((cl) => getOptions(cl.id, phrase))
  );

  const options = customLabels.reduce((acc, cl, index) => {
    if (results[index].length) {
      return [
        ...acc,
        ...results[index].map((val) => ({
          label: val.name,
          key: `${cl.name}+${val.name}`,
          id: cl.id
        }))
      ];
    }
    return acc;
  }, [] as FacetOption[]);

  return scoredSuggestions(options)(phrase);
};
